import { TIMELINE_READ_MORE_MARKER } from "articlePage/timelineArticle/timelineSpecialData"

interface TimelineItemTextProps {
    text: string
    isExpanded: boolean
    onExpand: () => void
}

export const splitTimelineItemText = (text: string) => {
    const source = text || ""
    const markerIndex = source.indexOf(TIMELINE_READ_MORE_MARKER)
    if (markerIndex === -1) {
        return { preview: source, rest: "", hasMore: false }
    }

    return {
        preview: source.slice(0, markerIndex).replace(/\s+$/, ""),
        rest: source.slice(markerIndex + TIMELINE_READ_MORE_MARKER.length).replace(/^\s+/, ""),
        hasMore: true,
    }
}

export class TimelineItemText extends React.Component<TimelineItemTextProps> {
    private onExpandClick = (e: React.MouseEvent) => {
        e.preventDefault()
        e.stopPropagation()
        this.props.onExpand()
    }

    public render() {
        const { text, isExpanded } = this.props
        const { preview, rest, hasMore } = splitTimelineItemText(text)

        if (!preview && !rest) {
            return null
        }

        const isCollapsed = hasMore && !isExpanded
        const previewText = isCollapsed && preview && !preview.trim().endsWith("…") ? `${preview}…` : preview

        return (
            <div className={`timeline-new-item-text ${isCollapsed ? "is-collapsed" : ""}`}>
                <div className="timeline-new-item-text-body">
                    <p className="timeline-new-item-text-preview">{previewText}</p>

                    {hasMore && isExpanded && rest &&
                        <p className="timeline-new-item-text-rest">{rest}</p>
                    }
                </div>

                {isCollapsed &&
                    <div className="timeline-new-read-more-line" />
                }

                {isCollapsed &&
                    <button type="button" className="timeline-new-read-more-btn" onClick={this.onExpandClick}>
                        <span>{__("Read more")}</span>

                        <span className="timeline-new-read-more-icon" aria-hidden="true" />
                    </button>
                }
            </div>
        )
    }
}
